import React from "react";
import "./RatesTable.css";

const rates = [
  { name: "Swift Desire", seater: "4+1", price: "₹12" },
  { name: "Aura", seater: "4+1", price: "₹12" },
  { name: "Toyota Etios", seater: "4+1", price: "₹14" },
  { name: "Ertiga", seater: "6+1", price: "₹15" },
  { name: "Innova", seater: "6+1", price: "₹18" },
  { name: "Scorpio", seater: "8+1", price: "₹18" },
  { name: "Innova Crysta", seater: "6+1", price: "₹20" },
  { name: "Audi", seater: "4+1", price: "On Call" },
  { name: "Tempo Traveller", seater: "13/17 Seater", price: "On Call" },
  { name: "Mini Bus", seater: "20 Seater", price: "On Call" },
  { name: "Bus", seater: "32-52", price: "On Call" },
  { name: "Tavera", seater: "8+1", price: "₹18" },
  { name: "Kia Carens", seater: "6+1 / 7+1", price: "₹17 / ₹18" },
];

const RatesTable = () => {

  const handleWhatsApp = (vehicleName) => {
    const phoneNumber = "918767592195"; // No space, no +
    const message = `Hello Lotus Cab, I want to book ${vehicleName}. Please share details.`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    
    window.open(whatsappURL, "_blank");
  };

  return (
    <div className="rates-container">
      <h2 className="title">Rates for AC Buses</h2>

      <div className="table-wrapper">
        <table className="rates-table">
          <thead>
            <tr>
              <th>Bus Name</th>
              <th>Seater</th>
              <th>Per KM</th>
              <th>Driver Food</th>
              <th>Toll & Parking</th>
              <th>Book</th>
            </tr>
          </thead>
          <tbody>
            {rates.map((bus, index) => (
              <tr key={index}>
                <td>{bus.name}</td>
                <td>{bus.seater}</td>
                <td>{bus.price}</td>
                <td>Extra</td>
                <td>Extra</td>
                <td>
                  <button
                    className="book-btn"
                    onClick={() => handleWhatsApp(bus.name)}
                  >
                    Book Now
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Mobile Cards */}
        <div className="mobile-cards">
          {rates.map((bus, index) => (
            <div className="card" key={index}>
              <h3>{bus.name}</h3>
              <p><strong>Seater:</strong> {bus.seater}</p>
              <p><strong>Per KM:</strong> {bus.price}</p>
              <p><strong>Driver Food:</strong> Extra</p>
              <p><strong>Toll & Parking:</strong> Extra</p>
              <button
                className="book-btn full"
                onClick={() => handleWhatsApp(bus.name)}
              >
                Book Now
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RatesTable;
